import BaseLayout from "../../components/Layout";
import "./styles.scss";
import React, { useCallback } from "react";
import Progress from "../../components/Progress";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { actionGetPontosMonitoriaByLoja } from "../../features/monitoramento/lista-pontos/slices";
import FilterGruposMonitoria from "../../components/FilterGruposMonitoria";
import conectSocket from "../../helpers/connect-socket";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import { AlertCircleIcon, WrenchIcon } from "lucide-react";

const PageListPontosDeMonitoria = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const pontosMonitoriaByLoja = useAppSelector(
    (state) => state.pontosMonitoriaByLoja,
  );

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const lojas = useAppSelector((state) => state.getLojas.lojas);

  const initialState = {
    filter: null,
    listPontosDeMonitoria: [],
    pontoSelecionado: null,
  } as any;

  const [state, setState] = React.useState(initialState);
  const getGrupoSelected = (filter: any) => setState({ ...state, filter });

  const createList = useCallback(
    (data) => {
      if (!data) return;

      const currentFilter = state.filter;

      const filtered = !currentFilter
        ? data
        : data.filter(({ id }) => id === currentFilter);

      const listPontosDeMonitoria = filtered
        .map((item) => [
          ...item.listaMonA,
          ...item.listaMonD,
          ...item.listaMonR,
        ])
        .flat();

      setState((prevState) => ({
        ...prevState,
        listPontosDeMonitoria,
      }));
    },
    [state.filter],
  );

  React.useEffect(() => {
    dispatch(actionGetPontosMonitoriaByLoja(lojaSelected));
  }, [dispatch, lojaSelected]);

  React.useEffect(() => {
    if (pontosMonitoriaByLoja?.data?.grupoMonitor) {
      createList(pontosMonitoriaByLoja.data.grupoMonitor);
    }
  }, [pontosMonitoriaByLoja, createList]);

  React.useEffect(() => {
    if (!lojaSelected) return;

    const connection = conectSocket({
      url: `hubLoja?idLoja=${lojaSelected}`,
      hub: "PostLojaHub",
      cb: (responseSocket) => {
        createList(responseSocket.grupoMonitor);
      },
    });

    return () => {
      if (connection) {
        connection.stop();
      }
    };
  }, [lojaSelected, createList]);

  const handleOpenPonto = (ponto: any) => {
    setState((prevState) => ({ ...prevState, pontoSelecionado: ponto }));
  };

  const handleClosePonto = () => {
    setState((prevState) => ({ ...prevState, pontoSelecionado: null }));
  };

  const calcularTempoParado = (dataFalhaStr: string, statusOk: boolean) => {
    if (statusOk || !dataFalhaStr || dataFalhaStr.startsWith("0001")) return "";

    const dataFalha = new Date(dataFalhaStr);
    const agora = new Date();
    const diferencaMs = agora.getTime() - dataFalha.getTime();

    if (diferencaMs <= 0) return "Parado há menos de 1 min";

    const minutos = Math.floor(diferencaMs / (1000 * 60));
    const horas = Math.floor(diferencaMs / (1000 * 60 * 60));
    const dias = Math.floor(diferencaMs / (1000 * 60 * 60 * 24));

    if (dias > 0) return `Parado há ${dias} ${dias === 1 ? "dia" : "dias"}`;
    if (horas > 0)
      return `Parado há ${horas} ${horas === 1 ? "hora" : "horas"}`;
    return `Parado há ${minutos} min`;
  };

  const formatarData = (dataStr?: string) => {
    if (!dataStr || dataStr.startsWith("0001")) return "-";
    return new Date(dataStr).toLocaleString("pt-BR");
  };

  const getStatusInfo = (p: any) => {
    if (p.isManutencao) {
      return { label: "Em Manutenção", className: "maintenance" };
    }
    if (!p.online) {
      return { label: "Offline", className: "offline" };
    }
    return p.statusOk
      ? { label: "Normal", className: "positive" }
      : { label: "Alerta", className: "negative" };
  };
  const ponto = state.pontoSelecionado;
  const statusInfo = ponto ? getStatusInfo(ponto) : null;

  const calcularTempoManutencao = (horarioFim?: string) => {
    if (!horarioFim || horarioFim.startsWith("0001")) return "";

    const fim = new Date(horarioFim);
    const agora = new Date();
    const diffMs = fim.getTime() - agora.getTime();

    if (diffMs <= 0) return "Prazo de manutenção encerrado";

    const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const horas = Math.floor(diffMs / (1000 * 60 * 60));
    const minutos = Math.floor(diffMs / (1000 * 60));

    if (dias > 0) return `Encerra em ${dias} ${dias === 1 ? "dia" : "dias"}`;
    if (horas > 0)
      return `Encerra em ${horas} ${horas === 1 ? "hora" : "horas"}`;
    return `Encerra em ${minutos} min`;
  };

  console.log("state.listPontosDeMonitoria", state.listPontosDeMonitoria);

  return (
    <BaseLayout>
      <div className="container">
        <div className="row">
          <>
            {lojas.length > 0 && (
              <div className="container" style={{ marginBottom: "1.5rem" }}>
                <strong style={{ fontSize: "2rem", fontWeight: 700 }}>
                  {lojas.find((loja) => loja.id === Number(lojaSelected))?.nome}
                </strong>
              </div>
            )}
          </>
          <div className="col-4 mb-20">
            <FilterGruposMonitoria cb={getGrupoSelected} />
          </div>
        </div>
      </div>
      {lojaSelected ? (
        <div className="list-pts-monitoria">
          {state.listPontosDeMonitoria.length > 0 ? (
            state.listPontosDeMonitoria.map((item: any) => {
              const {
                equipamento,
                statusOk,
                comentarios,
                sequenciaItem,
                msgFalhaCustom,
                msgNormalCustom,
                limiteInf,
                limiteSup,
                idCentral,
                adrModulo,
                idEntrada,
                escalaInf,
                escalaSup,
                valor,
                dataFalha,
                unidadeMedida,
                diaMedicao,
                lastPostString,
                online,
              } = item;

              return (
                <div
                  key={`${idCentral}-${adrModulo}-${idEntrada}-${sequenciaItem}`}
                  className={`card-monitoria ${
                    item.isManutencao
                      ? "maintenance"
                      : online
                        ? statusOk
                          ? "positive"
                          : "negative"
                        : "offline"
                  }`}
                  style={{ position: "relative" }}
                >
                  <div className="card-monitoria__content">
                    <header>
                      <div>
                        <div className="mb-5">
                          <h2 className="heading heading--sm">
                            {equipamento.nome} {sequenciaItem}
                          </h2>
                          
                        </div>
                        {item.isManutencao && (
                          <span className="badge-manutencao">
                            <WrenchIcon size={12} />
                            {calcularTempoManutencao(
                              item.manutencao?.horarioFim,
                            ) || "Em manutenção"}
                          </span>
                        )}

                        {!item.isManutencao && !statusOk && (
                          <span className="badge-tempo-parado">
                            {calcularTempoParado(dataFalha, statusOk)}
                          </span>
                        )}

                        {equipamento.tipo === "A" && (
                          <>
                            <p className="paragraph paragraph--sm">
                              <strong>Limite inferior:</strong> {limiteInf}{" "}
                              {unidadeMedida}
                            </p>
                            <p className="paragraph paragraph--sm">
                              <strong>Limite superior:</strong> {limiteSup}{" "}
                              {unidadeMedida}
                            </p>
                          </>
                        )}

                        {equipamento.tipo === "R" && (
                          <p className="paragraph paragraph--sm">
                            <strong>Fechamento:</strong>
                            {" Dia "} {diaMedicao}
                          </p>
                        )}
                      </div>
                      <div className="figure">
                        <div className="figure__icon">
                          <img src={equipamento.imagem} alt="" />
                        </div>
                        <div className="figure__text">
                          <p className="paragraph paragraph--sm">
                            <strong>
                              {idCentral}-{adrModulo}-{idEntrada}
                              {equipamento.tipo}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </header>

                    <article>
                      <div>
                        <p className="paragraph paragraph--sm">{comentarios}</p>
                      </div>
                      <div>
                        {statusOk && (
                          <p className="paragraph paragraph--md">
                            <strong>{msgNormalCustom}</strong>
                          </p>
                        )}
                        {!statusOk && (
                          <p className="paragraph paragraph--sm">
                            <strong>{msgFalhaCustom}</strong>
                          </p>
                        )}
                      </div>
                    </article>

                    <div className="footer">
                      {equipamento.tipo === "A" && (
                        <Progress
                          min={escalaInf}
                          max={escalaSup}
                          current={valor}
                          legend={`${valor} ${unidadeMedida}`}
                        />
                      )}
                      {equipamento.tipo === "R" && (
                        <Progress
                          min={0}
                          max={valor * 2}
                          current={valor}
                          legend={`${valor} ${unidadeMedida}`}
                        />
                      )}
                      <div className="infoPost">
                        <p>{lastPostString}</p>
                      </div>
                    </div>
                  </div>

                  {(item.isManutencao || !statusOk) && (
                    <button
                      type="button"
                      className={`alert-indicator-btn ${item.isManutencao ? "maintenance-btn" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenPonto(item);
                      }}
                      title={
                        item.isManutencao ? "Ver manutenção" : "Ver alerta"
                      }
                    >
                      {item.isManutencao ? (
                        <WrenchIcon size={22} />
                      ) : (
                        <AlertCircleIcon size={24} />
                      )}
                    </button>
                  )}
                </div>
              );
            })
          ) : (
            <strong>Nenhum ponto de monitoramento</strong>
          )}
        </div>
      ) : (
        <div className="container">
          <strong>
            Selecione uma loja para listar os pontos de monitoramento
          </strong>
        </div>
      )}

      {ponto && statusInfo && (
        <Modal
          size="md"
          overflow
          header={
            <div className={`ponto-modal-header ${statusInfo.className}`}>
              <div className="ponto-modal-header__icon">
                <img src={ponto.equipamento?.imagem} alt="" />
              </div>
              <div className="ponto-modal-header__info">
                <span className={`status-pill ${statusInfo.className}`}>
                  {statusInfo.label}
                </span>
                <h3 className="heading heading--sm">
                  {ponto.equipamento?.nome} {ponto.sequenciaItem}
                </h3>
                <p className="paragraph paragraph--sm ponto-modal-header__code">
                  {ponto.idCentral}-{ponto.adrModulo}-{ponto.idEntrada}
                  {ponto.equipamento?.tipo} · {ponto.modeloModulo}
                </p>
              </div>
            </div>
          }
          callbackCancel={handleClosePonto}
          actions={
            <div style={{ display: "flex", gap: "0.5rem" }}>
              {statusInfo?.className === "negative" && (
                <Button
                  size="sm"
                  onClick={() => navigate("/pontos-de-monitoramento/alertas")}
                >
                  Ver alerta
                </Button>
              )}
              <Button size="sm" onClick={handleClosePonto}>
                Fechar
              </Button>
            </div>
          }
        >
          <div className="ponto-modal-body">
            <div className={`ponto-modal-message ${statusInfo.className}`}>
              <p className="paragraph paragraph--md">
                {ponto.statusOk ? ponto.msgNormalCustom : ponto.msgFalhaCustom}
              </p>
              {!ponto.statusOk && (
                <span className="ponto-modal-message__time">
                  {calcularTempoParado(ponto.dataFalha, ponto.statusOk)}
                </span>
              )}
            </div>

            <div className="ponto-modal-grid">
              <div className="ponto-modal-grid__item">
                <span className="label">Comentário</span>
                <span className="value">{ponto.comentarios || "-"}</span>
              </div>
              <div className="ponto-modal-grid__item">
                <span className="label">Última atualização</span>
                <span className="value">
                  {ponto.lastPostString?.replace("Última Atualização: ", "")}
                </span>
              </div>
              {!ponto.statusOk && (
                <div className="ponto-modal-grid__item">
                  <span className="label">Em falha desde</span>
                  <span className="value">{formatarData(ponto.dataFalha)}</span>
                </div>
              )}
              {ponto.dataVoltaNormal &&
                !ponto.dataVoltaNormal.startsWith("0001") && (
                  <div className="ponto-modal-grid__item">
                    <span className="label">Normalizado em</span>
                    <span className="value">
                      {formatarData(ponto.dataVoltaNormal)}
                    </span>
                  </div>
                )}
            </div>

            {(ponto.descricao || ponto.procedimento) && (
              <div className="ponto-modal-section ponto-modal-section--alert">
                {ponto.descricao && (
                  <div className="ponto-modal-section__block">
                    <span className="ponto-modal-section__title">
                      ⚠ Descrição do alerta
                    </span>
                    <p className="paragraph paragraph--sm">{ponto.descricao}</p>
                  </div>
                )}
                {ponto.procedimento && (
                  <div className="ponto-modal-section__block">
                    <span className="ponto-modal-section__title">
                      ✓ Procedimento
                    </span>
                    <p className="paragraph paragraph--sm">
                      {ponto.procedimento}
                    </p>
                  </div>
                )}
              </div>
            )}

            {ponto.isManutencao && ponto.manutencao && (
              <div className="ponto-modal-section ponto-modal-section--maintenance">
                <div className="ponto-modal-section__header">
                  <span className="ponto-modal-section__title">
                    🔧 Manutenção Programada
                  </span>
                  <span className="status-pill sm maintenance">
                    {ponto.manutencao.status}
                  </span>
                </div>

                <div className="ponto-modal-grid">
                  <div className="ponto-modal-grid__item">
                    <span className="label">Início</span>
                    <span className="value">
                      {formatarData(ponto.manutencao.horarioInicio)}
                    </span>
                  </div>
                  <div className="ponto-modal-grid__item">
                    <span className="label">Fim previsto</span>
                    <span className="value">
                      {formatarData(ponto.manutencao.horarioFim)}
                    </span>
                  </div>
                  <div className="ponto-modal-grid__item">
                    <span className="label">Tipo</span>
                    <span className="value">
                      {ponto.manutencao.tipoManutencao}
                    </span>
                  </div>
                  <div className="ponto-modal-grid__item">
                    <span className="label">Interrupção</span>
                    <span className="value">
                      {ponto.manutencao.descricaoInterrupcao}
                    </span>
                  </div>
                </div>

                {ponto.manutencao.observacao && (
                  <p className="paragraph paragraph--sm">
                    <strong>Obs:</strong> {ponto.manutencao.observacao}
                  </p>
                )}
              </div>
            )}

            {ponto.alertaAberto && (
              <div className="ponto-modal-section ponto-modal-section--open">
                <div className="ponto-modal-section__header">
                  <span className="ponto-modal-section__title">
                    Alerta aberto #{ponto.alertaAberto.id}
                  </span>
                  <span
                    className={`status-pill sm ${
                      ponto.alertaAberto.reconhecido ? "positive" : "negative"
                    }`}
                  >
                    {ponto.alertaAberto.reconhecido
                      ? "Reconhecido"
                      : "Não reconhecido"}
                  </span>
                </div>
                <p className="paragraph paragraph--sm">
                  {ponto.alertaAberto.descricao}
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}
    </BaseLayout>
  );
};

export default PageListPontosDeMonitoria;
